const agentAdd = {
    path: 'agent/add',
    component: resolve => require(['../../../../../pages/admin/channel/agent/add'], resolve),
    meta: {
        requireAuth: true
    }
}

export default agentAdd